import React from 'react';
import useConcessionsBannerController from 'client/components/SrConcessionsBanner/useConcessionsBannerController';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrTextList from 'client/components/SrTextList';

import './SrConcessionsBanner.less';

const SrConcessionsBanner = ({ concession, rentPrice }) => {
  const controller = useConcessionsBannerController({ concession, rentPrice });

  return (
    <SrBox styleName="SrConcessionsBanner">
      <SrBox styleName="starIconContainer">
        <SrBox styleName="starIcon" />
      </SrBox>
      <SrText font="greycliff" color="blue300" fontSize="21px" lineHeight="28px" weight="800">
        {controller.title}
      </SrText>
      <SrBox>
        <SrText font="greycliff" color="orange300" fontSize="16px" lineHeight="22px" weight="700">
          {controller.remainingTime}
        </SrText>
      </SrBox>
      <SrBox marginTop="8px">
        <SrTextList textList={controller.concessionDetails} />
      </SrBox>
    </SrBox>
  );
};

SrConcessionsBanner.displayName = 'SrConcessionsBanner';

export default SrConcessionsBanner;
